import { useTranslation } from 'react-i18next';
import { Odd } from 'types/Odd';
import { SlipEntry } from 'types/SlipEntry';

/**
 * One line under the slip's figures: when the ticket wins, and what it pays -
 * with combinations (several picks on a match), how they are made.
 */
export const SlipPayoutNote = ({
  className,
  bets = 1,
  system = false,
}: {
  className?: string;
  bets?: number;
  /** A system ticket: its combinations are sets of matches. */
  system?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <p className={className}>
      {t(
        system
          ? 'slip_payout_note_system'
          : bets > 1
            ? 'slip_payout_note'
            : 'slip_payout_note_single'
      )}
    </p>
  );
};

/**
 * All odds of one market of the slip entry's match: team picks that the feed
 * tells apart only by their order need them (see describePick).
 */
export const marketOddsOf = (
  entry: SlipEntry,
  betName?: string | null
): Odd[] | null => {
  const bets = (
    entry.match as { bets?: { name?: string | null; odds?: Odd[] }[] }
  ).bets;
  return bets?.find((b) => b.name === betName)?.odds ?? null;
};
